import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';

export const statusToColour = {
    loading: 'grey',
    error: 'red',
    warning: 'orange',
    expectedError: 'grey',
    success: 'green',
    unknown: 'grey',
} as const satisfies Record<StatusMessage['status'], string>;
